module.exports = __webpack_public_path__ + "media/images/phone/story-script_tap-visual@3x-c80be338a3f7a2540d1c4722718fc508.png";